export default "__VITE_ASSET__C4i1y_Jd__"